<ub-card>
    <h2 title>{{ tableComponentOptions.tableTitle }}</h2>
    <div content>
        <eas-interactive-table [options]="tableComponentOptions"></eas-interactive-table>
    </div>
</ub-card>